const isErrorEvent = event => (
	event.ev === 'CE' || (event.ev === 'CR' && event.respMsg != 'OK' && event.respMsg != '' && event.respMsg != null)
)

export { isErrorEvent };
